import React from "react";
import { Grid, Switch } from "@material-ui/core";
import { SrLabel } from "components/common";

const NotificationItem = ({ checked, onChange, name, onBlur, label }) => (
  <Grid container item alignItems="center" justifyContent="space-between">
    <Grid item xs={8} md={5}>
      <SrLabel name={name}>{label}</SrLabel>
    </Grid>
    <Grid item xs={2}>
      <Switch
        name={name}
        id={name}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Grid>
  </Grid>
);

export default NotificationItem;
